import {Dialog} from 'platform/components';
import {Box} from 'platform/foundation';

import {useState} from 'react';

import {isEmpty} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface CampaignAddVehicleDialogProps extends RequiredTestIdProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (vehicleIds: string[]) => void;
}

export function CampaignAddVehicleDialog(props: CampaignAddVehicleDialogProps) {
  const [selectedVehicleIds, setSelectedVehicleIds] = useState<string[]>([]);

  const handleClose = () => {
    setSelectedVehicleIds([]);
    props.onClose();
  };

  const handleConfirm = () => {
    props.onConfirm(selectedVehicleIds);
    setSelectedVehicleIds([]);
    props.onClose();
  };

  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={handleClose}
      size="large"
      title={i18n.t('entity.salesCampaign.labels.selectVehicles')}
      data-testid={suffixTestId('addVehicleDialog', props)}
      buttons={[
        {
          title: i18n.t('general.actions.cancel'),
          variant: 'secondary',
          onClick: handleClose,
          'data-testid': suffixTestId('addVehicleDialog-cancel', props),
        },
        {
          title: i18n.t('general.labels.select'),
          variant: 'primary',
          onClick: handleConfirm,
          isDisabled: isEmpty(selectedVehicleIds),
          'data-testid': suffixTestId('addVehicleDialog-confirm', props),
        },
      ]}
    >
      <Box height="60vh">
        <DmsDataGrid
          gridCode="campaign-add-vehicle-os"
          onRowSelectionChange={(rows) => setSelectedVehicleIds(rows.map((row) => row.id))}
          data-testid={suffixTestId('addVehicleGrid', props)}
        />
      </Box>
    </Dialog>
  );
}
